import { HeartPulse, Sparkles, Leaf } from "lucide-react";
import { whyChoose } from "../mock";

const iconMap = { HeartPulse, Sparkles, Leaf };

export default function WhyChoose() {
  return (
    <div className="mt-10 grid gap-6 md:grid-cols-3">
      {whyChoose.map((w) => {
        const Icon = iconMap[w.icon] || Leaf;
        return (
          <div key={w.title} className="rounded-2xl bg-white border border-neutral-200 p-7 hover:shadow-lg hover:-translate-y-1 transition-all">
            <div className="w-12 h-12 rounded-xl bg-green-600 text-white flex items-center justify-center">
              <Icon size={22} />
            </div>
            <h3 className="mt-4 text-lg font-bold text-neutral-900">{w.title}</h3>
            <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{w.desc}</p>
          </div>
        );
      })}
    </div>
  );
}
